module.exports = __webpack_public_path__ + "img/overLay_close.1e7c5b4d.svg";